import { useTableState as useReactStatelyTableState } from "@react-stately/table";
import { STATELY_SORT_DIRECTION, STATELY_SORT_DIRECTION_REVERSE } from "../utils/sort";
export function useKalepTableState({ children, disabledKeys, hasRowSelection, selectedRows, onSelectRow, orderBy, onOrderByChange, allIds = [], hasClearSorting, }) {
    const isNumericId = allIds.length && typeof allIds[0] === "number";
    return useReactStatelyTableState({
        // Only multiple selection is supported, hence always mapping to it when row selection is enabled
        selectionMode: hasRowSelection ? "multiple" : "none",
        showSelectionCheckboxes: hasRowSelection,
        selectedKeys: ensureStringArray(selectedRows),
        disabledKeys: ensureStringArray(disabledKeys),
        // Handler that is called when selection changes in react-stately table state.
        onSelectionChange: (selection) => {
            const disabledIds = [...(disabledKeys || [])];
            if (selection === "all") {
                onSelectRow === null || onSelectRow === void 0 ? void 0 : onSelectRow(allIds.filter((id) => !disabledIds.includes(id) || (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.includes(id))));
            }
            else {
                const keysArray = [...selection.keys()];
                // We need to map the selection results to proper ID type because by default we get an array of strings
                // but we also support numeric IDs and would like to return selection IDs array with proper types
                const mappedKeys = isNumericId ? keysArray.map((id) => Number(id)) : keysArray;
                onSelectRow === null || onSelectRow === void 0 ? void 0 : onSelectRow([...mappedKeys, ...disabledIds.filter((id) => selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.includes(id))]);
            }
        },
        // Handler that is called when sorting changes in react-stately table state.
        // We prefer this callback to custom click handlers due to the fact that it has built-in keyboard support.
        onSortChange: (sortDescriptor) => {
            var _a;
            if (!sortDescriptor.column) {
                return;
            }
            let newDirection;
            if (hasClearSorting && (orderBy === null || orderBy === void 0 ? void 0 : orderBy.key) === sortDescriptor.column) {
                if ((orderBy === null || orderBy === void 0 ? void 0 : orderBy.direction) === "ASC") {
                    newDirection = "DESC";
                }
                else if ((orderBy === null || orderBy === void 0 ? void 0 : orderBy.direction) === "DESC") {
                    newDirection = undefined;
                }
                else {
                    newDirection = "ASC";
                }
            }
            else {
                newDirection = STATELY_SORT_DIRECTION_REVERSE[(_a = sortDescriptor === null || sortDescriptor === void 0 ? void 0 : sortDescriptor.direction) !== null && _a !== void 0 ? _a : STATELY_SORT_DIRECTION.ASC];
            }
            const updatedOrderBy = newDirection === undefined
                ? undefined
                : {
                    key: sortDescriptor === null || sortDescriptor === void 0 ? void 0 : sortDescriptor.column,
                    direction: newDirection,
                };
            onOrderByChange === null || onOrderByChange === void 0 ? void 0 : onOrderByChange(updatedOrderBy);
        },
        sortDescriptor: {
            column: orderBy === null || orderBy === void 0 ? void 0 : orderBy.key,
            direction: (orderBy === null || orderBy === void 0 ? void 0 : orderBy.direction) ? STATELY_SORT_DIRECTION[orderBy.direction] : undefined,
        },
        children,
    });
}
function ensureStringArray(ids) {
    if (!ids) {
        return ids;
    }
    if (typeof ids[0] === "number") {
        return ids.map((id) => String(id));
    }
    return ids;
}
